import React from 'react';
import { Form, Select, InputNumber, Button, Card, message } from 'antd';
import { debugLog } from '../../utils/debug';
const { Option } = Select;

const StaffTransfer = () => {
    const [form] = Form.useForm();

    // This would typically come from your API/database
    const staffMembers = [
        { id: 1, name: 'John Doe' },
        { id: 2, name: 'Jane Smith' },
        { id: 3, name: 'Mike Johnson' },
    ];

    const onFinish = (values) => {
        debugLog('Transfer values:', values);    
        message.success('Amount transferred successfully!');
        form.resetFields();
    };

    return (
        <div className="container mt-4">
            <Card title="Staff Transfer" className="shadow-sm">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="fromStaff"
                        label="From Staff"
                        rules={[{ required: true, message: 'Please select sender' }]}
                    >
                        <Select placeholder="Select sender">
                            {staffMembers.map(staff => (
                                <Option key={staff.id} value={staff.id}>{staff.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="toStaff"
                        label="To Staff"
                        rules={[{ required: true, message: 'Please select recipient' }]}
                    >
                        <Select placeholder="Select recipient">
                            {staffMembers.map(staff => (
                                <Option key={staff.id} value={staff.id}>{staff.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="amount"
                        label="Transfer Amount"
                        rules={[{ required: true, message: 'Please enter amount' }]}
                    >
                        <InputNumber
                            style={{ width: '100%' }}
                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            placeholder="Enter amount to transfer"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" block>
                            Transfer Amount
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default StaffTransfer; 
